import { useLanguageContext } from "../../context/LanguageContext";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../styles/CardStyles";
import { StyledFlexColumn, StyledFlexRow } from "../../styles/LayoutStyles";
import InputWrapper from "../input/wrapper/InputWrapper";
import LanguageFormSelect from "../select/custom/language/form/LanguageFormSelect";
import Select from "../select/main/Select";

function EntityTranslationsContainerView({ controller, children, style }) {
  const { translate } = useLanguageContext();

  return (
    <StyledCard style={style}>
      <StyledCardHeader>
        <StyledFlexRow style={{ alignItems: "center" }}>
          <h2>{translate("eva.main.entities.translations")}</h2>

          <LanguageFormSelect
            value={controller?.languageId}
            onChange={controller?.onLanguageChange}
          />
        </StyledFlexRow>
      </StyledCardHeader>

      <StyledCardBody>
        <StyledFlexColumn>
          {controller.currentTranslation && (
            <InputWrapper
              label={translate("eva.main.validation.attributes.default")}
            >
              <Select
                value={controller.getValue("default")}
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                onChange={(val) =>
                  controller.onTranslationChange(val, "default")
                }
              />
            </InputWrapper>
          )}

          {children}
        </StyledFlexColumn>
      </StyledCardBody>
    </StyledCard>
  );
}

export default EntityTranslationsContainerView;
